import { getApiClient } from '@plandi/common'
import { components } from '@plandi/common/src/generated'

import { PorfolioProjectsQueryParams } from './portfolio.types'

export const portfolioApi = {
  getProfilePortfolioProjectList: (
    locale: string,
    profileId: number,
    params?: PorfolioProjectsQueryParams
  ) =>
    getApiClient(locale)
      .get<components['schemas']['PortfolioProjectListResource']>(
        `v1/profiles/${profileId}/projects`,
        { params }
      )
      .then(({ data }) => data.data),

  getPortfolioProjectBySlug: (slug: string, locale: string) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['ProfileProjectResource'] }>(
        `v1/profiles/projects/${slug}`
      )
      .then(({ data }) => data.data),

  addLikeProject: (projectId: number, locale: string) =>
    getApiClient(locale)
      .post<{ likes?: number }>(`v1/profiles/projects/${projectId}/like`)
      .then(({ data }) => data),

  dislikeProject: (projectId: number, locale: string) =>
    getApiClient(locale)
      .delete<{ likes?: number }>(`v1/profiles/projects/${projectId}/like`)
      .then(({ data }) => data),

  deleteProject: (projectId: number, locale: string) =>
    getApiClient(locale)
      .delete(`v1/profiles/projects/${projectId}`)
      .then(({ data }) => data),

  addProjectToPortfolio: (
    profileId: number,
    requestBody: components['schemas']['AddProjectToPortfolio'],
    locale: string
  ) =>
    getApiClient(locale)
      .post<{ data: { slug?: string } }>(
        `v1/profiles/${profileId}/projects`,
        requestBody
      )
      .then(({ data }) => data.data),

  updateProjectFromPortfolio: (
    projectId: number,
    requestBody: components['schemas']['AddProjectToPortfolio'],
    locale: string
  ) =>
    getApiClient(locale)
      .put(`v1/profiles/projects/${projectId}`, requestBody)
      .then(({ data }) => data)
}
